import { JstsPolygon } from 'Plugins/FloorPlan/Utils/JstsUtils';
import { ProduitDto } from '../../../../Models/Questions/ProduitDto';
import { CoordPoint } from '../../Utils/Types';
import { LaizeBandItemV3 } from './v3/LaizeBandTrace';
import { CalculateOptimalBandsLayoutParams, RoomGroupDebug } from './v3/LaizeV3';
import { StairsStepType } from 'Plugins/FloorPlan/Models/IRoom';

export enum LameFlooringLayout {
    //* LamePleine Directions
    LamePleine = 'LameVertical',
    //* Lame Optimisé Directions
    ClassiqueVertical = 'ClassiqueVertical', //kept as is for retrocompat. Previously Vertical / Horizontal.
}

export enum ProductType {
    LamePleine = 'lamePleine',
    Rouleau = 'rouleau',
}

export enum BandType {
    New = 'band-new', //* nouvelle bande
    Reused = 'band-reused', //band réutilisée
    Reusable = 'band-reusable', //* chute
    NewPotential = 'band-new-potential',
    SurfaceCovered = 'surface-covered',
    SurfaceCoveredPotential = 'surface-covered-potential',
}

export enum Direction {
    LeftToRight = 'leftToRight',
    RightToLeft = 'rightToLeft',
}

export interface LaizeProps {
    produit?: ProduitDto;
    productCode?: string;
    type?: ProductType;

    largeurCm?: number;
    longueurCm?: number;
    raccordCm?: number;
    largeurMarginCm?: number;
    longueurMarginCm?: number;

    //! V3
    roomIds?: Array<string>;

    remonteesPlinthesMarginCm?: number;
}

export const DEFAULT_LAIZE_PROPS: LaizeProps = {
    productCode: '',
    type: undefined,
    largeurCm: 100,
    longueurCm: 500,
    raccordCm: 0,
    largeurMarginCm: 0,
    longueurMarginCm: 0,
    roomIds: [],
};

export type LaizeBand = {
    id: number; //!\\ l'itération où la bande d'un produit a été générée
    length: number;
    leftOverUsed?: boolean;

    //!v3
    roomId?: string;
    leftOverCoords?: CoordPoint[][];
    surfaceCoveredCoords?: CoordPoint[];
};

export type LaizeResult = {
    laizes?: Array<LaizeBand>; //* Bandes utilisées
    // horizontal?: number; //* Total ML (ou nombres de lames) dans le sens horizontal
    // vertical?: number; //* Total ML (ou nombres de lames) dans le sens vertical

    calculator?: LaizeCalculatorResult; //* Résultat du calculateur

    roomIds?: Array<string>; //* RoomIds used in the laize computer
    laizeProps?: LaizeProps; //* Product used in the laize computer
    result?: number;
    roomsRaccordLength?: Array<LaizeRoomRaccord>;

    /**
     * List of possible flooring wall start by roomId with their laizeResult.
     */
    possibleFlooringWallStartByRoomId?: Array<{
        roomId: string;
        value: Array<{ wallId: string; laizeResult?: number }>;
    }>;
};

export type LaizeRoomRaccord = { roomId: string; length: number; direction: string };

export type LaizeBandDetails = {
    roomId: string;
    bands: Array<LaizeBand>;
    leftOverBandHasBeenReusedInThisRoom?: boolean;
};

export type LaizeCalculatorResult = {
    isPossible: boolean;

    laizeResult: number;

    roomsRaccordLength: Array<LaizeRoomRaccord>;
    roomsBandsLength: Array<number>;
    roomsBandsDetails: Array<LaizeBandDetails>;
    roomsBandsDetailsContiguous: Array<LaizeBand>;

    //!ONLY TO TRACE IN MAP
    requestedBy?: string;
    bands_v3?: Array<LaizeBandItemV3>;
    iteration?: number;

    /**
     * List of possible flooring wall start by roomId with their laizeResult.
     */
    possibleFlooringWallStartByRoomId?: Array<{
        roomId: string;
        value: Array<{ wallId: string; laizeResult?: number }>;
    }>;

    hasValidCurrentWallStart: boolean;

    roomGroupsDebug?: RoomGroupDebug[];

    params?: CalculateOptimalBandsLayoutParams;
};

export type StairsResult = {
    points: Array<CoordPoint>;
    contremarcheLine?: { p1: CoordPoint; p2: CoordPoint };
    pointsWithMargin: Array<CoordPoint>;
    type?: StairsStepType;
    bandIndex: number;
    bandId: string;
    indexOnBand: number;
    wholeIndex: number;
    stairId: string;
    staircaseId: string;
    staircaseIndex: number;
    staircaseName: string;
    staircaseFloor?: string;
};

export type LaizeStairsResult = {
    laizeResult: number;
};

export type LaizeStairsCalculatorResult = {
    band: {
        points: Array<CoordPoint>;
        remainingBand: JstsPolygon;
    };
    stairs: Array<StairsResult>;
} & LaizeStairsResult;
